var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCroissant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-croissant",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.6 13.11 5.79-3.21c1.89-1.05 4.79 1.78 3.71 3.71l-3.22 5.81C8.8 23.16.79 15.23 4.6 13.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.5 9.5-1-2.29C9.2 6.48 8.8 6 8 6H4.5C2.79 6 2 6.5 2 8.5a7.71 7.71 0 0 0 2 4.83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6c0-1.55.24-4-2-4-2 0-2.5 2.17-2.5 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14.5 13.5 2.29 1c.73.3 1.21.7 1.21 1.5v3.5c0 1.71-.5 2.5-2.5 2.5a7.71 7.71 0 0 1-4.83-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16c1.55 0 4-.24 4 2 0 2-2.17 2.5-4 2.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroissant);
export default __webpack_public_path__ + "static/media/croissant.d26cbf8f09735d3d7d079fac0292746e.svg";
export { ForwardRef as ReactComponent };